import http from './index'

const $ajax = (url, data, method = 'GET', obj) => {
	let params = obj ? { url, method, data, ...obj } : { url, method, data }
	return http.httpServer(params)
}
const $ajax1 = (url, data, method = "GET", obj) => {
  let params = obj ? { url, method, data, ...obj } : { url, method, data };
  return http.httpServer2(params);
};
const $ajax2 = (url, data, method = "GET", obj) => {
  let params = obj ? { url, method, data, ...obj } : { url, method, data };
  return http.httpServer3(params);
};

export const Login = {
	mobile: data => $ajax('/login/mobile', data, 'POST'), // 手机号密码登录
	email: data => $ajax('/login/email', data, 'POST'), // 邮箱密码登录
	mobileCode: data => $ajax('/login/mobile/code', data, 'POST'), // 手机号验证码登录
	wechatCode: data => $ajax('/login/wechat', data), // 获取微信登录二维码
	wechatCheck: data => $ajax('/login/wechat/check', data, 'POST'), // 轮询微信登录状态
	weworkCode: data => $ajax('/wework/code/url', data), // 获取二维码登录
	weworkCheck: data => $ajax('/wework/check/join/team', data, 'POST'), // 检验用户是否加入团队
	getCode: data => $ajax('/captcha/get/code', data), // 获取图形验证码
	getSmsCode: data => $ajax('/sms/send', data, 'POST'), // 登录前获取验证码 type 类型 1登录 4找回
	getSmsUserCode: data => $ajax('/sms/send/user', data, 'POST'), // 登录后获取验证码 type 类型 2修改 3绑定
	getUserInfo: data => $ajax('/user/info', data), // 获取用户信息
	setPassword: data => $ajax('/user/set/password', data, 'POST'), // 修改密码
	forgetPassword: data => $ajax('/user/forget/password', data, 'POST'), // 忘记密码
	bindMobile: data => $ajax('/login/wechat/bind/mobile', data, 'POST'), // 绑定手机号
	changeMobile: data => $ajax('/user/change/mobile', data, 'POST'), // 修改手机号
	noMibileBindMobile: data => $ajax('/user/bind/mobile', data, 'POST'), // 没有手机号的时候绑定手机号
	logout: data => $ajax('/login/logout', data), // 退出登录
}
export const User = {
	userCheck: data => $ajax('/user/check', data), // 身份验证
	userSetPassword: data => $ajax('/user/set/password', data, 'POST'), // 修改密码
	emailBind: data => $ajax('/user/email/bind', data, 'POST'), // 绑定邮箱
	emailUnbind: data => $ajax('/user/email/unbind', data, 'POST'), // 绑定邮箱
	emailUnbindNoMobile: data => $ajax('/user/email/unbind/un', data, 'POST'), // 没有手机号验证 解绑邮箱
	emailCode: data => $ajax('/user/email/code', data, 'POST'), // 邮箱验证码
	emailChange: data => $ajax('/user/email/change', data, 'POST'), // 邮箱修改
	changeName: data => $ajax('/user/change/nickname', data, 'POST'), // 修改昵称
	changeImage: data => $ajax('/user/change/image', data, 'POST'), // 修改头像
	upLoadBase64: data => $ajax('/upload/base64/image', data, 'POST'), // base64格式上传
	changeDepartment: data => $ajax('/user/change/department', data, 'POST'), // 修改部门
}
export const getTeam = data => $ajax('/home/team/list', data) // 获取团队列表
export const uploadImgApi = data => $ajax('/upload/oss/token', data, 'POST') //图片上传
export const changeTeam = data => $ajax('/home/change/team', data, 'POST') // 切换团队

export const Brand = {
	brands: data => $ajax('/brands/index', data), // 品牌logo/颜色/字体 列表
	colorRemove: data => $ajax('/brands/colors/remove', data), // 删除颜色
	colorAdd: data => $ajax('/brands/colors', data, 'POST'), // 新增颜色
	fontsRemove: data => $ajax('/brands/fonts/remove', data, 'DELETE'), // 删除字体
	deleteLogo: data => $ajax('/brands/logo/delete', data, 'POST'), // 删除logo
	uploadLogo: data => $ajax('/brands/logo/upload', data, 'POST'), // 上传新增logo
	renameLogo: data => $ajax('/brands/logo/rename', data, 'POST'), // logo重命名
	Fonts: data => $ajax('/template/fonts', data), // 获取字体列表
	getType: data => $ajax('/brands/fonts/fonttypes', data), // 工作台是否显示品牌字体
	setType: data => $ajax('/brands/fonts/set/fonttype', data, 'POST'), // 设置工作台是否显示品牌字体
	fontUpload: data => $ajax('/brands/fonts/upload', data, 'POST'), // 字体上传
	downloadLogo: data => $ajax('/brands/logo/download', data), // 品牌logo下载验证
}
export const Member = {
	applies: data => $ajax('/team/member/applies', data), // 获取待审批人员列表
	memberList: data => $ajax('/team/member', data), // 团队成员列表
	remove: data => $ajax('/team/member', data, 'DELETE'), // 删除团队成员
	audit: data => $ajax('/team/member/audit', data, 'POST'), // 审批成员
	add_team_member: data => $ajax('/team/member/add', data, 'POST'), // 添加成员
	edit_team_member: data => $ajax('/team/member/edit', data, 'POST'), // 编辑成员
	edit_role: data => $ajax('/team/member/edit/role', data, 'POST'), // 编辑成员角色
	invitation: data => $ajax('/team/member/invitation', data), // 邀请成员
	isjoined: data => $ajax('/team/member/isjoined', data, 'POST'), // 用户是否加入被邀请的团队
	invitor: data => $ajax('/team/member/invitor', data), // 获取邀请信息
	joinTeam: data => $ajax('/team/member/join', data, 'POST'), // 用户是否加入被邀请的团队
	move_founder: data => $ajax('/team/member/move/founder', data, 'POST'), //转移创建者
	rename: data => $ajax('/team/rename', data, 'POST'), //修改团队名称
	add_excel_member: data => $ajax('/team/member/add/excel', data, 'POST'), // 导入成员
	getCurrentTeam: data => $ajax('/team/current', data), // 获取当前团队
}
export const Space = {
	directory: data => $ajax('/space/my/space/get/dir', data), // 获取文件夹
	createDir: data => $ajax('/space/my/space/create/dir', data, 'POST'), // 新建
	renameDir: data => $ajax('/space/my/space/rename/dir', data, 'POST'), // 重命名
	deleteDir: data => $ajax('/space/my/space/delete/dir', data, 'POST'), // 删除
	myspaces: data => $ajax('/space/my/space/design/list', data), // 获取我的空间列表数据
	createNewFile: data => $ajax('/space/my/space/design/copy', data, 'POST'), // 创建副本接口
	rename: data => $ajax('/space/my/space/rename/design', data, 'post'), //设计重命名
	move: data => $ajax('/space/my/space/move/design', data, 'POST'), //移动设计
	delete: data => $ajax('/space/my/space/delete/design', data, 'POST'), // 删除设计
	savePSD: data => $ajax('/save/psd', data, 'POST'), // 上传psd(保存psd)
}

export const Collect = {
	getData: data => $ajax('/space/my/space/collect/list', data), // 我的收藏列表
	// collect: data => $ajax('/team/teamuser/collect/template', data, 'POST'), // 收藏企业模板
	uncollect: data => $ajax('/space/my/space/uncollect/template', data, 'POST'), // 取消收藏企业模板
}

export const TemplateCenter = {
	getData: data => $ajax('/template/image', data), // 列表
	class: data => $ajax('/template/class', data), // 分类
	scene: data => $ajax('/template/scene', data), // 场景
	hotkeyword: data => $ajax('/template/hotkeyword', data), // 热搜词
	industry: data => $ajax('/template/image/industry', data), // 用途
	styles: data => $ajax('/template/image/styles', data), // 风格
	collect: data => $ajax('/template/image/collect', data, 'POST'), // 收藏模板
	uncollect: data => $ajax('/template/image/uncollect', data, 'POST'), // 取消收藏模板
	recommend: data => $ajax('/template/image/recommend', data), // 推荐模板列表
	sceneList: data => $ajax('/template/scene/class/list', data), // 需求场景列表
	demand: data => $ajax('/template/image/demand', data, 'POST'), // 提交需求
	searchWord: data => $ajax('/template/preset/search/word', data), // 预置搜索词
	templateDetail: data => $ajax('/template/image/details', data), // 模板详情
}

export const Home = {
	getData: data => $ajax('/home/info', data, 'GET'), // 首页管理获取展示信息
}

export const HomeSetting = {
	basicSetting: data => $ajax('/home/basic/setting', data, 'POST'), // 基础信息配置
	configSetting: data => $ajax('/home/config/setting', data, 'POST'), // 设置首页其他配置
	templateSetting: data => $ajax('/home/config/template/setting', data, 'POST'), // 设置首页模板分类配置 仅限type = 4
	choose: data => $ajax('/home/template/choose/list', data), // 已选模板
	dirList: data => $ajax('/home/directory/list', data), // 跳转链接配置-获取文件夹列表
	templateList: data => $ajax('/home/template/list', data), // 跳转链接配置-获取模板列表
}

export const Template = {
	templates: data => $ajax('/teamwork/team/templates', data), // 获取列表数据
	renameDir: data => $ajax('/teamwork/team/templates/rename/dir', data, 'POST'), // 重命名文件夹
	deleteDir: data => $ajax('/teamwork/team/templates/delete/dir', data, 'POST'), // 删除文件夹
	createDir: data => $ajax('/teamwork/team/templates/create/dir', data, 'POST'), // 创建文件夹
	collect: data => $ajax('/teamwork/team/templates/collect/template', data, 'POST'), // 收藏模板
	renameTemplate: data => $ajax('/teamwork/team/templates/rename/template', data, 'POST'), // 重命名模板
	getDir: data => $ajax('/teamwork/team/templates/get/dir', data), // 获取文件夹
	move: data => $ajax('/teamwork/team/templates/move/template', data, 'POST'), // 模板移动
	delete: data => $ajax('/teamwork/team/templates/delete/template', data, 'POST'), // 删除模板
	upUserInfo: data => $ajax('/user/upuser/info', data, 'POST'), // 更新用户信息
}

export const Copyright = {
	getLinkList: data => $ajax('/friendship/links', data), // 获取底部链接
	getDemoList: data => $ajax('/copyright/demoimage/download/list', data), // 样图下载记录
	getAuthorizeList: data => $ajax('/copyright/authorize/list', data), // 我的授权记录
	addAuthorize: data => $ajax('/copyright/authorize/add', data, 'POST'), // 提交授权书
	downloadAuthorize: data => $ajax('/copyright/authorize/download', data), // 下载授权书
	getPrincipalList: data => $ajax('/copyright/principal/list', data), // 我的授权主体列表
	downloadPhoto: data => $ajax('/copyright/orgphoto/download', data), // 下载团队版权素材（原图）接口
}

export const Materials = {
	getData: data => $ajax('/workbench/team/materials', data), // 企业素材
	move: data => $ajax('/teamwork/team/materials/move/style', data, 'POST'), // 企业素材移动
	rename: data => $ajax('/teamwork/team/materials/rename/style', data, 'POST'), // 企业素材重命名
	renameDirectory: data => $ajax('/teamwork/team/materials/rename/directory', data, 'POST'), // 企业素材文件夹重命名
	createDirectory: data => $ajax('/teamwork/team/materials/create/directory', data, 'POST'), // 企业素材新建文件夹
	deleteDirectory: data => $ajax('/teamwork/team/materials/delete/directory', data, 'POST'), // 企业素材删除文件夹
	upload: data => $ajax('/teamwork/team/materials/upload', data, 'POST'), // 企业素材上传素材
	directory: data => $ajax('/workbench/team/materials/directory', data), // 企业素材文件夹列表
	delete: data => $ajax('/teamwork/team/materials/delete/style', data, 'POST'), // 企业素材删除文件
}
export const cutOutImage ={
	imageCutout : (data) => $ajax("/image/cutout", data, "POST"),
	refineCutout: (data) => $ajax("/image/cutout/refine", data, "POST")
}


export const contactUs = (data) => $ajax("/team/cooperate/apply", data, "POST");

export const getCase = (data) => $ajax1("/get/case/list", data, "POST");

export const getCaseDetail = (data) => $ajax1("/get/case/info", data, "POST");

export const getFooterList = (data) => $ajax1("/get/case/recommend", data, "POST");

export const Report = {
	getReportList: data => $ajax2("/api_microdreams/report/index", data),
	getReportInfo: data => $ajax2("/api_microdreams/report/info", data)
}

export const Statistics = {
	statistics_personal_design_data: data => $ajax('/statistics/user/design/total', data), // 获取个人作品统计数据
	statistics_enterprise_data: data => $ajax('/statistics/team/design/total', data), // 获取团队作品统计数据
	statistics_use_num: data => $ajax('/statistics/copyright/image/use/num', data), // 获取版权图片用量
	statistics_use_num_details: data => $ajax('/statistics/copyright/image/use/num/details', data), // 获取版权图用量明细
	statistics_use_data: data => $ajax('/statistics/copyright/image/use/data', data), // 获取版权图使用数据列表
	statistics_use_data_export: (data, obj) =>
		$ajax('/statistics/copyright/image/use/data/export', data, 'GET', obj), // 获取版权图用量明细导出
	statistics_enterprise_design_download_data: data =>
		$ajax('/statistics/team/design/download/data', data), // 作品下载数据
	statistics_enterprise_design_download_data_export: (data, obj) =>
		$ajax('/statistics/team/design/download/export', data, 'GET', obj), // 作品下载数据导出
	statistics_enterprise_design_download_all: data =>
		$ajax('/statistics/team/design/download/data/all', data), // 作品下载数据-全部
	statistics_use_num_details_export: (data, obj) =>
		$ajax('/statistics/copyright/image/use/num/export', data, 'GET', obj), // 版权图用量明细导出
	statistics_team_design_total_details: data =>
		$ajax('/statistics/team/design/total/details', data), // 获取作品统计明细列表
	statistics_team_design_total_export: (data, obj) =>
		$ajax('/statistics/team/design/total/details/export', data, 'GET', obj), // 获取作品统计明细列表
	statistics_member_ship_data: data => $ajax('/statistics/member/ship/data', data, 'GET'), // 成员数据
	statistics_member_ship_data_list: data => $ajax('/statistics/member/detail/list', data, 'GET'), // 成员数据明细
	statistics_member_detail_line: data => $ajax('/statistics/member/detail/line', data, 'GET'), // 折线图
	statistics_member_design_data: data => $ajax('/statistics/member/design/data', data, 'GET'), // 成员作品数据
	statistics_member_detail_export: (data, obj) =>
		$ajax('/statistics/member/detail/export', data, 'GET', obj), // 成员情况明细列表导出
	statistics_member_active_export: (data, obj) =>
		$ajax('/statistics/member/detail/active/export', data, 'GET', obj), // 账号活跃详情导出
	statistics_member_design_data_export: (data, obj) =>
		$ajax('/statistics/member/design/data/export', data, 'GET', obj), // 成员作品数据导出
}
